export function roundedToFixed(input, digits){
    var rounded = Math.pow(10, digits);
    return (Math.round(input * rounded) / rounded).toFixed(digits);
  }


// WEBPACK FOOTER //
// ./src/providers/trend-live-services/round.ts